import React from 'react';
import Button from '@material-ui/core/Button';
import CalculatorDialog from 'components/Loans/CalculatorDialog';
import AlertDialog from 'components/AlertDialog';
import { submitApplication, approveApplication, rejectApplication, requestDoc, authorizeApplication } from '/actions/applications';
import { CheckboxAlertDialog } from '../FormComponents';

export default class ActionButtons {
  constructor({dirty, dispatch, application, history}) {
    this.dispatch = dispatch;
    this.application = application;
    this.orgId = application.organisationId;
    this.dirty = dirty;
    this.history = history;
  }

  isDocRequested = () => this.application.status === 'doc_requested';

  onCancel = () => this.history.push('/applications');

  onUpdate = () => this.dispatch(submitApplication(this.application.number));

  onAuthorize = (authorized) => this.dispatch(authorizeApplication({appNumber: this.application.number, authorized }));

  onReject = () => this.dispatch(rejectApplication(this.application.number));

  onApprove = () => this.dispatch(approveApplication(this.application.number));

  cancel = () => (
    <Button onClick={this.onCancel}>
      CANCEL
    </Button>
  );

  reject = () => (
    <AlertDialog
      buttonLabel='Reject'
      color='secondary'
      confirmAction={this.onReject}
      name='reject'
      title='You are about to reject the application, please confirm.'
      desc='Rejection will obsolete the application, which cannot be undone.'
    />
  )

  defaultBtns = () => (
    <React.Fragment>
      { this.reject() }
      { this.cancel() }
    </React.Fragment>
  )

  update = () => {
    if (this.dirty) {
      return (
        <Button variant='raised' color='primary' onClick={this.onUpdate}>
          Update
        </Button>
      );
    }
    return null;
  }

  authorize = () => {
    if (this.application.appType !== 'referral') {
      return null;
    }
    if (this.application.authorized) {
      return (
        <Button variant='raised' color='primary' onClick={() => {this.onAuthorize(false)}}>
          Un-authorize
        </Button>
      );
    } else {
      return (
        <Button variant='raised' color='primary' onClick={() => {this.onAuthorize(true)}}>
          Authorize
        </Button>
      );
    }
  }

  requestedDocLink = () => {
    if (this.application.sharedFolderUrl) {
      return (
        <div>
          <p>Note: Additional document(s) have been requested before for this application.</p>
          <p><a href={this.application.sharedFolderUrl} target='_blank'>View additional documents</a></p>
        </div>
      )
    }
  }

  requestDoc = () => {
    const reqDocs = [
      {label: "Driver's licence", value: 'driver_licence'},
      {label: 'Last 3 months business bank statements', value: 'last_3_months_business_bank_statements'},
      {label: 'Last 2 quarters BAS', value: 'last_2_quarters_bas'},
      {label: 'Copy of ATO tax portal', value: 'copy_of_ato_tax_portal'},
      {label: 'Most recent financial statement', value: 'most_recent_financial_statement'}
    ];

    return (
      <CheckboxAlertDialog
        color='primary'
        buttonLabel='Request Doc'
        options={reqDocs}
        note={this.requestedDocLink()}
        submit={options=>{this.dispatch(requestDoc(this.application.number, options))}}
        title='Request Doc'
      />
    );
  }

  quote = () => {
    if (this.isDocRequested() || this.application.authorized) {
      return (
        <CalculatorDialog
          buttonLabel='Quote'
          applicationNumber={this.application.number}
          organisationId={this.orgId}
        />
      );
    }
    return null;
  };

  approve = () => {
    if (this.application.status === 'quoted') {
      return (
        <AlertDialog
          buttonLabel='Approve'
          variant='raised'
          color='secondary'
          confirmAction={this.onApprove}
          name='approve'
          title='You are about to approve the application, please confirm.'
          desc='Successful approval will send a contract to Amazy representative to sign first. After signing by Amazy rep, a contract will be sent to the applicant to sign in order to complete the contract agreement.'
        />
      );
    }
  }

  renderBtns = () => {
    if (this.dirty) {
      return (
        <React.Fragment>
          { this.update() }
          { this.defaultBtns() }
        </React.Fragment>
      );
    } else if (!this.application.authorized) {
      return (
        <React.Fragment>
          { this.authorize() }
          { this.defaultBtns() }
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        { this.authorize() }
        { this.requestDoc() }
        { this.quote() }
        { this.approve() }
        { this.defaultBtns() }
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/ActionButtons.js